import { getLastPageUrl } from "@utils/pageTracker";

let accordionListenerInitialized = false;
const GTM = {
  // Global Page Level Data Layer
  pageView: (pageInfo = {}, siteInfo = {}) => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "page_view",
        pageInfo: {
			pageName: window.location.hash !== '' ? window.location.pathname + window.location.hash : window.location.pathname?.replace('/', '')?.replaceAll('-', ' '),
			pageURL: window.location.href || "",
			section: window.location.pathname?.replace('/', '')?.replaceAll('-', ' ') || "",
			subsection: "not_available",
			language: pageInfo.language || "en-US",
			country: "US"
        },
        siteInfo: {
          clientName: "pacira",
          siteName: siteInfo.siteName || "exparel",
          siteCategory: siteInfo.siteCategory || "consumer"
        }
	  });

			if (document.title.includes('500') || document.title.includes('404')) {
				window.dataLayer.push({ event: "error_page_load", eventInfo: { httpCode: document.title.includes('500') ? '500' : '404', PagePathwithQueryStrings: window.location.href } });
			}
    }
  },

  isiClick: (linkText, action) => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
			window.dataLayer.push({
				event: "expansions",
				eventInfo: {
					linkText,
					action
				}
			});
		}
	},

  videoPlay: (videoTitle, label = "Start") => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "video_plays",
        eventInfo: {
          videoTitle,
          label
        }
      });
    }
  },

  videoEnd: (videoTitle, label = "Complete") => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "video_ends",
        eventInfo: {
          videoTitle,
          label
        }
      });
    }
  },

  videoPercent: (videoTitle, percent) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "video_percent",
        eventInfo: {
          videoTitle,
          label: `${percent}%`
        }
      });
    }
  },

  videoInterval: (videoTitle, seconds) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "video_interval_seconds",
        eventInfo: {
          videoTitle,
          label: `${seconds}`
        }
      });
    }
  },

  formDelivery: (formName, interstitialName = "") => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "form_delivery",
        eventInfo: {
          formName,
          label: interstitialName
        }
      });
    }
  },

  formFieldCompletion: (formName, fieldName, fieldValue) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "field_completion",
        eventInfo: {
          formName,
          fieldName,
          fieldValue
        }
      });
    }
  },

  formInitiation: (formName) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "form_initiation",
        eventInfo: {
          formName,
          label: ""
        }
      });
    }
  },

	fieldValidation: (formName, fieldName, fieldError) => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
			window.dataLayer.push({
				event: "validation_errors",
				eventInfo: {
					formName,
					fieldName,
					fieldError
				}
			});
		}
	},

  formSubmission: (formName) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "form_submissions",
        eventInfo: {
          formName,
          label: "Complete"
        }
      });
    }
  },

  trackCTA: () => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
			document.addEventListener('click', (event) => {
				if (event.target.closest('a, button')) {
					if (event.target.closest('header')) {
						if (event.target.closest('.gtm-header')) {
							window.dataLayer.push({
								event: "navigation_click",
								eventInfo: {
                                    currentPage : getLastPageUrl(),
									destinationURL: event.target.href,
									position: "Header",
									linkText: event.target.textContent || event.target.innerText
								}
							});
						} else if (event.target.closest('.gtm-nav')) {
							window.dataLayer.push({
								event: "navigation_click",
								eventInfo: {
                                    currentPage : getLastPageUrl(),
									destinationURL: event.target.href,
									position: "Navbar",
									linkText: event.target.textContent || event.target.innerText
								}
							});
						}
					} else if (event.target.closest('footer')) {
						window.dataLayer.push({
							event: "navigation_click",
							eventInfo: {
                                currentPage : getLastPageUrl(),
								destinationURL: event.target.href,
								position: "Footer",
								linkText: event.target.textContent || event.target.innerText
							}
						});
					} else {
						if (!event.target.closest('.accordion-button') && !event.target.closest('.video-card') && !event.target.closest('.isi-bar') && !event.target.closest('.sticky-isi') && !event.target.closest('form') && !event.target.closest('.carousel-controls')) {
							window.dataLayer.push({
								event: "cta_click",
								eventInfo: {
                                    currentPage : getLastPageUrl(),
									destinationURL: event.target.href || "",
									linkText: event.target.textContent || event.target.innerText,
									location: "Body"
								}
							});
						}
					}
				}
			});
		}
	},

    trackAccordion: () => {
        if (accordionListenerInitialized) return;
        accordionListenerInitialized = true;

        if (typeof window !== 'undefined' && "dataLayer" in window) {
            document.addEventListener('click', (event) => {
                const accordionButton = event.target.closest('.accordion-button');
                if (accordionButton) {
                    const isExpanded = accordionButton.getAttribute('aria-expanded') === 'true';
                    const action = isExpanded ? 'Expand' : 'Collapse';
                    const label = accordionButton.querySelector('span')?.textContent?.trim() || '';

                    window.dataLayer.push({
                        event: "expansions",
                        eventInfo: {
                            action,
                            linkText: label
                        }
                    });
                }
            });
        }
    },

  formSubmissionDetails: (formName, details) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "form_submissions_details",
        eventInfo: {
          formName,
          label: details
        }
      });
    }
  },

  carouselClick: (event) => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
      let title = 'homepage';
      let label = document.querySelector('.carousel-container .current-slide h3').textContent;
      let linkText = "";

      if (event.target.closest('#next-slide') || event.target.closest('#prev-slide')) {
        if (event.target.closest('#next-slide')) {
          linkText = document.querySelector('.next-slide h3').textContent;
        } else if (event.target.closest('#prev-slide')) {
          linkText = document.querySelector('.prev-slide h3').textContent;
        }
        window.dataLayer.push({
          event: "carousel-click",
          eventInfo: {
            title: title,
            label: label,
            linkText: linkText
          }
        });
      }
		}
	},

	trackOpenModal: (modalName) => {
		if (typeof window !== 'undefined' && "dataLayer" in window) {
			window.dataLayer.push({
				event: "interstitial_load",
				eventInfo: {
					label: modalName
				}
			});
		}
	},

  trackInterstitialDismiss: (linkText, modalName) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "interstitial_dismiss",
        eventInfo: {
          linkText,
          label: modalName
        }
      });
    }
  },

  trackOutboundLink: (destinationURL, label) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "outbound_links",
        eventInfo: {
          destinationURL,
          label
        }
      });
    }
  },

  errorPage: (code) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "error_page_load",
        eventInfo: {
          httpCode: code,
          PagePathwithQueryStrings: window.location.pathname + window.location.search
        }
      });
    }
  },
  
  reset: () => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
		  window.dataLayer = [];
	  }
  },

  trackAnchorLink: (anchorURL, linkText) => {
    if (typeof window !== 'undefined' && "dataLayer" in window) {
      window.dataLayer.push({
        event: "anchor-linkclick",
        eventInfo: {
          anchorURL,
          linkText
        }
      });
    }
  },
};

export default GTM;
